module.exports = __webpack_public_path__ + "img/zerno-bg.19ad262f.png";